import React from "react";
import Header from "./components/front/header/Header";
import Footer from "./components/front/footer/Footer";
import AppRouting from "./AppRouting";


const Layout = () => {
  return (
    <div>
      <Header />
      <AppRouting />
      <Footer />
    </div>
  );
};

export default Layout;
